import { render, staticRenderFns } from "./ModalSuporteHospitalLogo.vue?vue&type=template&id=3ccf2faa&scoped=true"
import script from "./ModalSuporteHospitalLogo.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteHospitalLogo.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteHospitalLogo.vue?vue&type=style&index=0&id=3ccf2faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf2faa",
  null
  
)

export default component.exports